<template>
	<AuthLayout :mustBeSelected="false">
		<Dialog title="Select a Homey">
			<span v-if="loading">Loading...</span>
			<ListView class="select-homey-list" :items="items" :showIndex="true" @selected="select" v-else></ListView>
		</Dialog>
	</AuthLayout>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';
	import { Getter, Action } from 'vuex-class';
	import AuthLayout from '../../layouts/Auth/index.vue';
	import Dialog from '../../components/Dialog';
	import ListView from '../../components/ListView';
	import KeyListenerView from '../../components/KeyListenerView';

	@Component({
		components: {
			AuthLayout,
			Dialog,
			ListView,
		},
	})
	export default class SelectHomey extends KeyListenerView {
		@Getter('api/homey/all') homeys;
		@Getter('api/homey/isConnecting') isConnecting;
		@Action('api/homey/selectHomey') selectHomey;
		@Action('api/homey/retrieveAll') getHomeys;
		@Action('api/logout') logout;
		@Prop({ type: String }) redirectTo;

		loading = false;

		get items() {
			if (!this.homeys) {
				if (!this.isConnecting) {
					this.getHomeys();
				}
				return [];
			}
			if (this.homeys.length === 0) {
				// TODO write message that you need a Homey
			}
			return this.homeys.map(homey => ({
				title: homey.state === 'online' ? homey.name : `${homey.name} (Offline)`,
				id: homey.id,
				name: homey.name,
				online: homey.state === 'online',
				class: { offline: homey.state !== 'online' },
			}));
		}

		select({ id, online, name }) {
			if (!online) return;
			this.loading = true;
			this.selectHomey({ id, name })
				.then(() => {
					this.loading = false
					if (this.redirectTo) {
						this.$router.push(this.redirectTo);
					} else {
						this.$router.push('/devices');
					}
				})
				.catch(() => {
					this.loading = false;
				});
		}

		mounted() {
			this.addKeyboardListener('L', this.onLogout, 'Logout');
			super.mounted();
		}

		destroyed() {
			super.destroyed();
		}

		onLogout() {
			this.logout();
			this.$router.push('login');
		}
	}
</script>

<style lang="scss">
	.select-homey-list .offline {
		color: darkgrey;
	}
</style>